// Клиентский BFF-слой домена `system`.
// Источник истины: `contract.md` §3.4 (клиент вызывает ТОЛЬКО собственный origin
// портала — `/api/system/year`; Frappe-обёртка `message` снята в `portalFetch` на
// сервере, поэтому клиент и браузер работают с **развёрнутой** формой — §6-11).
//
// Контракт функции (`contract.md` §3.4):
//   • URL: относительный `/api/system/year` (own origin); никаких `/api/method/...`
//     и никаких `API_BASE_URL`/`resolveClientApiBaseUrl` из эталона.
//   • cache: `force-cache`; credentials по умолчанию `same-origin` (guest; cookie не нужен).
//   • НЕ выставляет `Authorization`-заголовок (`AGENTS.md`, `pattern_portal_architecture.mdc`).
//   • Успех → `number` (год); non-2xx / malformed / network error → `null` молча
//     (без throw, без показа пользователю). `null` — сигнал для Footer использовать fallback.
//   • Никаких `console.*` (`pattern_code_style.mdc`).

interface SystemYearSuccess {
  success: true;
  year: number;
}

interface SystemYearError {
  success: false;
  error: { code: string; message: string };
}

type SystemYearResponse = SystemYearSuccess | SystemYearError;

/**
 * Текущий год с сервера (для копирайта). BFF-нога `GET /api/system/year`.
 *
 * Возвращает `number` (год) или `null` при любой неудаче (HTTP-ошибка, malformed-тело,
 * сетевой сбой). `null` — сигнал для Footer использовать fallback `new Date().getFullYear()`.
 */
export async function getSystemYear(): Promise<number | null> {
  try {
    const res = await fetch('/api/system/year', { cache: 'force-cache' });
    if (!res.ok) return null;

    const data: SystemYearResponse = await res.json();
    if (data.success !== true) return null;

    return typeof data.year === 'number' ? data.year : null;
  } catch {
    return null;
  }
}
